import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { green, purple, red, orange } from '@material-ui/core/colors';

export default function ColorButton(props) {
	const { children, color, ...rest } = props;
	if (!color || color === 'primary') {
		return <Button {...{ ...rest, color }}>{children}</Button>;
	}

	const mappingColor = {
		green,
		purple,
        red,
        orange,
	};

	const CustomButton = withStyles((theme) => ({
		root: {
			color: theme.palette.getContrastText(purple[500]),
			backgroundColor: mappingColor[color][500],
			'&:hover': {
				backgroundColor: mappingColor[color][700],
			},
		},
	}))(Button);

	return <CustomButton {...rest}>{children}</CustomButton>;
}
